/**
 * `parseNpy` upcasts every dtype to a flat `Float64Array` uniformly
 * (`src/data/codecs/npy.ts`); these helpers narrow that back down to the
 * concrete typed array a consumer actually needs (e.g. `Uint16Array` for a
 * region-id array), rounding for integer dtypes so a float rounding error
 * from the upcast round-trip never off-by-ones an id.
 */

export function toFloat32(data: Float64Array): Float32Array {
  return Float32Array.from(data);
}

export function toUint32(data: Float64Array): Uint32Array {
  return Uint32Array.from(data, (value) => Math.round(value));
}

export function toUint16(data: Float64Array): Uint16Array {
  return Uint16Array.from(data, (value) => Math.round(value));
}

export function toUint8(data: Float64Array): Uint8Array {
  return Uint8Array.from(data, (value) => Math.round(value));
}
